import { render } from "./Shroff.vue?vue&type=template&id=2118d486&scoped=true"
import script from "./Shroff.vue?vue&type=script&lang=js"
export * from "./Shroff.vue?vue&type=script&lang=js"

import "./Shroff.vue?vue&type=style&index=0&id=2118d486&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2118d486"]])

export default __exports__